import React,{useState}from"react";
import{Box,Button,Container,IconButton,InputAdornment,Paper,Stack,TextField,Typography}from"@mui/material";
import{EmailOutlined,LockOutlined,Visibility,VisibilityOff}from"@mui/icons-material";
import{useNavigate}from"react-router-dom";
import{useAuth}from"../context/AuthContext";
import{useAlert}from"../context/AlertContext";

export default function Login(){
  const navigate=useNavigate();
  const{login}=useAuth();
  const{showError,showSuccess}=useAlert();

  const[form,setForm]=useState({
    username:"",
    password:"",
  });

  const[showPassword,setShowPassword]=useState(false);
  const[loading,setLoading]=useState(false);

  const handleChange=(e)=>{
    const{name,value}=e.target;
    setForm((prev)=>({
      ...prev,
      [name]:value,
    }));
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();

    if(!form.username.trim()||!form.password){
      showError("Ingrese su correo y contraseña.");
      return;
    }

    setLoading(true);

    try{
      const user=await login(
        form.username.trim(),
        form.password
      );

      if(user?.must_change_password){
        showSuccess("Debe actualizar su contraseña para continuar.");
        navigate("/update-password",{replace:true});
        return;
      }

      showSuccess("Sesión iniciada correctamente.");
      navigate("/admin-panel",{replace:true});
    }catch(error){
      showError(
        error.message||
        "Correo o contraseña incorrectos."
      );
    }finally{
      setLoading(false);
    }
  };

  const handleForgotPassword=()=>{};

  return(
    <Box
      sx={{
        minHeight:"100vh",
        bgcolor:"#f4f6f9",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        px:2,
        py:4,
      }}
    >
      <Container maxWidth="xs">
        <Paper
          variant="outlined"
          sx={{
            p:{xs:3,sm:4},
            borderRadius:3,
            borderColor:"#dfe4ea",
            boxShadow:"none",
            bgcolor:"#ffffff",
          }}
        >
          <Stack spacing={3}>
            <Box sx={{textAlign:"center"}}>
              <Box
                sx={{
                  width:58,
                  height:58,
                  borderRadius:2.5,
                  bgcolor:"#123f6d",
                  color:"#ffffff",
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  mx:"auto",
                  mb:2,
                  fontSize:22,
                  fontWeight:800,
                }}
              >
                GS
              </Box>

              <Typography
                sx={{
                  fontSize:25,
                  fontWeight:800,
                  color:"#182230",
                  lineHeight:1.2,
                }}
              >
                Group Services
              </Typography>

              <Typography
                sx={{
                  mt:.7,
                  fontSize:13.5,
                  color:"#667085",
                }}
              >
                Inicia sesión para continuar
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={handleSubmit}
            >
              <Stack spacing={2.2}>
                <Box>
                  <Typography
                    sx={{
                      mb:.7,
                      fontSize:13.5,
                      fontWeight:700,
                      color:"#344054",
                    }}
                  >
                    Correo electrónico
                  </Typography>

                  <TextField
                    name="username"
                    type="email"
                    value={form.username}
                    onChange={handleChange}
                    placeholder="correo@empresa.com"
                    size="small"
                    fullWidth
                    required
                    autoComplete="username"
                    InputProps={{
                      startAdornment:(
                        <InputAdornment position="start">
                          <EmailOutlined
                            sx={{
                              fontSize:18,
                              color:"#98a2b3",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root":{
                        borderRadius:2,
                        minHeight:42,
                      },
                      "& input":{
                        fontSize:14,
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{
                      mb:.7,
                      fontSize:13.5,
                      fontWeight:700,
                      color:"#344054",
                    }}
                  >
                    Contraseña
                  </Typography>

                  <TextField
                    name="password"
                    type={showPassword?"text":"password"}
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Ingrese su contraseña"
                    size="small"
                    fullWidth
                    required
                    autoComplete="current-password"
                    InputProps={{
                      startAdornment:(
                        <InputAdornment position="start">
                          <LockOutlined
                            sx={{
                              fontSize:18,
                              color:"#98a2b3",
                            }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment:(
                        <InputAdornment position="end">
                          <IconButton
                            type="button"
                            size="small"
                            onClick={()=>setShowPassword((prev)=>!prev)}
                            edge="end"
                            sx={{color:"#98a2b3"}}
                          >
                            {showPassword
                              ?<VisibilityOff sx={{fontSize:19}}/>
                              :<Visibility sx={{fontSize:19}}/>
                            }
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root":{
                        borderRadius:2,
                        minHeight:42,
                      },
                      "& input":{
                        fontSize:14,
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    display:"flex",
                    justifyContent:"flex-end",
                  }}
                >
                  <Button
                    type="button"
                    size="small"
                    onClick={handleForgotPassword}
                    sx={{
                      p:0,
                      minWidth:0,
                      textTransform:"none",
                      fontSize:12.5,
                      fontWeight:600,
                      color:"#123f6d",
                      "&:hover":{
                        bgcolor:"transparent",
                        textDecoration:"underline",
                      },
                    }}
                  >
                    ¿Olvidaste tu contraseña?
                  </Button>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="small"
                  disabled={loading}
                  sx={{
                    minHeight:42,
                    borderRadius:2,
                    textTransform:"none",
                    fontWeight:700,
                    fontSize:14,
                    boxShadow:"none",
                    bgcolor:"#123f6d",
                    "&:hover":{
                      bgcolor:"#0d3359",
                      boxShadow:"none",
                    },
                  }}
                >
                  {loading?"Ingresando...":"Iniciar sesión"}
                </Button>

                <Typography
                  sx={{
                    fontSize:11.5,
                    color:"#98a2b3",
                    textAlign:"center",
                    lineHeight:1.6,
                  }}
                >
                  Al iniciar sesión aceptas los{" "}
                  <Box
                    component="span"
                    sx={{
                      color:"#123f6d",
                      fontWeight:600,
                      cursor:"pointer",
                    }}
                  >
                    términos y condiciones
                  </Box>{" "}
                  del servicio.
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}